module.exports = __webpack_public_path__ + "img/oaFlowData161@3x.d2b67471.png";